export default __webpack_public_path__ + "static/media/2026_April_Bild.a3c56167.webp";